import { endPoints } from '@/configs/endPoints'
import { getStoredValue } from '@/hooks/common/use-session-storage';
import { IBoletoResponse } from '@/interfaces/boletos'
import { API_COBRANCAS } from '@/utils/cobrancas-fetcher'

export async function exportarBoleto(
  pedidoVendaId: string
): Promise<IBoletoResponse> {
  const unifiedBilling = getStoredValue('unifiedBilling') === 'true';
  const billingClosingDay = getStoredValue('billingClosingDay');
  const data = await API_COBRANCAS.getCustom<IBoletoResponse>(
    `${endPoints.exportarBoleto}?idPedidoVenda=${pedidoVendaId}`
  ).catch((erros: string[]) => {
    if (unifiedBilling) {
      erros.map((erro, index) => {
        if (erro.includes("{billingClosingDay}")) {
          var erroAjustado = erro.replace("{billingClosingDay}", billingClosingDay);
          erros.splice(index, 1, erroAjustado);
        }
        return erro;
      });
    }
    return Promise.reject((erros as any) as Error);
  });
  return data
}
